// Official transfers catalog lives in the database (Admin → Transfers) and is served via GET /api/transfers.
// Only the service-type metadata below remains static (labels are translated via i18n keys tr.type.*).
export const TRANSFER_TYPES = [
  { id: 'airport-hotel', label: 'Aeroporto → Hotel', ready: true },
  { id: 'hotel-experience', label: 'Hotel → Experiência', ready: false },
  { id: 'intercity', label: 'Transfer Interurbano', ready: true },
  { id: 'private-driver', label: 'Motorista Privado', ready: false },
  { id: 'boat', label: 'Transfer de Barco', ready: false },
];
